import _defineProperty from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var __jsx = React.createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useState, useEffect } from "react";
import Store from "../../../utils/Store";
import AwesomeIcon from "../../AwesomeIcon";
import { faXmark, faUserTag, faSearch, faMemoPad, faStar, faFileLines, faArrowsRotate, faCopy, faPaperPlane } from "@fortawesome/pro-regular-svg-icons";
import promptsData from "./prompts.json";
var iconMap = {
  faUserTag: faUserTag,
  faSearch: faSearch,
  faMemoPad: faMemoPad,
  faStar: faStar,
  faFileLines: faFileLines,
  faArrowsRotate: faArrowsRotate
};
var PromptsModal = function PromptsModal(_ref) {
  var isOpen = _ref.isOpen,
    onClose = _ref.onClose;
  var _useState = useState(""),
    searchQuery = _useState[0],
    setSearchQuery = _useState[1];
  useEffect(function () {
    var handleHashChange = function handleHashChange() {
      if (window.location.hash === "#prompts") {
        document.dispatchEvent(new CustomEvent("openPromptsModal"));
      } else {
        onClose();
      }
    };
    handleHashChange();
    window.addEventListener("hashchange", handleHashChange);
    return function () {
      return window.removeEventListener("hashchange", handleHashChange);
    };
  }, [onClose]);
  var handleCopyPrompt = function handleCopyPrompt(content) {
    navigator.clipboard.writeText(content);
  };
  var handleUsePrompt = function handleUsePrompt(content) {
    Store.update(function (s) {
      s.chatInputContent = content;
    });
    handleClose();
  };
  var handleClose = function handleClose() {
    Store.update(function (s) {
      s.isDraggableModalOpen = true;
    });
    window.location.hash = "";
    onClose();
  };
  var filteredSections = promptsData.sections.filter(function (section) {
    return section.title.toLowerCase().includes(searchQuery.toLowerCase()) || section.prompts.some(function (prompt) {
      return prompt.name.toLowerCase().includes(searchQuery.toLowerCase()) || prompt.content.toLowerCase().includes(searchQuery.toLowerCase());
    });
  }).map(function (section) {
    return _objectSpread(_objectSpread({}, section), {}, {
      prompts: section.title.toLowerCase().includes(searchQuery.toLowerCase()) ? section.prompts // Show all prompts if section title matches
      : section.prompts.filter(function (prompt // Filter prompts if only prompt content matches
      ) {
        return prompt.name.toLowerCase().includes(searchQuery.toLowerCase()) || prompt.content.toLowerCase().includes(searchQuery.toLowerCase());
      })
    });
  });
  if (!isOpen) return null;
  return /*#__PURE__*/React.createElement("div", {
    className: "fixed inset-0 z-50 overflow-y-auto"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-center min-h-screen px-4 pt-4 pb-20 text-center sm:block sm:p-0"
  }, /*#__PURE__*/React.createElement("div", {
    className: "fixed inset-0 transition-opacity",
    "aria-hidden": "true"
  }, /*#__PURE__*/React.createElement("div", {
    className: "absolute inset-0 bg-black opacity-75"
  })), /*#__PURE__*/React.createElement("div", {
    className: "inline-block align-bottom bg-gray-900 rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-4xl sm:w-full"
  }, /*#__PURE__*/React.createElement("div", {
    className: "bg-gray-900 px-4 pt-5 pb-4 sm:p-6 sm:pb-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex justify-between items-center mb-6"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "text-xl font-semibold text-white"
  }, "AI Assistant Prompts"), /*#__PURE__*/React.createElement("button", {
    onClick: handleClose,
    className: "text-gray-400 hover:text-white transition-colors"
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faXmark,
    size: "lg"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "mb-6"
  }, /*#__PURE__*/React.createElement("div", {
    className: "relative"
  }, /*#__PURE__*/React.createElement("input", {
    type: "text",
    placeholder: "Search prompts or sections...",
    value: searchQuery,
    onChange: function onChange(e) {
      return setSearchQuery(e.target.value);
    },
    className: "w-full px-4 py-3 pl-10 border border-gray-700 rounded-lg bg-gray-800 text-white placeholder-gray-400 focus:outline-none focus:border-teal-500"
  }), /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faSearch,
    className: "absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "max-h-[60vh] overflow-y-auto scrollbar-light dark:scrollbar"
  }, /*#__PURE__*/React.createElement("div", {
    className: "columns-1 md:columns-2 gap-4"
  }, filteredSections.map(function (section) {
    return /*#__PURE__*/React.createElement("div", {
      key: section.title,
      className: "break-inside-avoid mb-4"
    }, /*#__PURE__*/React.createElement("div", {
      className: "px-4 py-3 bg-gradient-to-r from-gray-800 to-gray-700 rounded-t-lg flex items-center mb-2 shadow-lg"
    }, /*#__PURE__*/React.createElement("div", {
      className: "p-2 bg-teal-500/10 rounded-lg mr-3"
    }, /*#__PURE__*/React.createElement(AwesomeIcon, {
      name: iconMap[section.icon],
      className: "text-teal-400"
    })), /*#__PURE__*/React.createElement("span", {
      className: "font-medium text-white"
    }, section.title)), /*#__PURE__*/React.createElement("div", {
      className: "space-y-2"
    }, section.prompts.map(function (prompt) {
      return /*#__PURE__*/React.createElement("div", {
        key: prompt.name,
        className: "relative bg-gradient-to-br from-gray-800 to-gray-900 rounded-lg overflow-hidden hover:from-gray-750 hover:to-gray-800 transition-all duration-200 shadow-lg"
      }, /*#__PURE__*/React.createElement("div", {
        className: "flex"
      }, /*#__PURE__*/React.createElement("div", {
        className: "flex-1 p-4"
      }, /*#__PURE__*/React.createElement("h4", {
        className: "font-medium text-white mb-2 flex items-center"
      }, /*#__PURE__*/React.createElement("span", {
        className: "bg-teal-500/10 text-teal-400 text-xs px-2 py-1 rounded mr-2"
      }, "Prompt"), prompt.name), /*#__PURE__*/React.createElement("div", {
        className: "mt-2"
      }, /*#__PURE__*/React.createElement("p", {
        className: "text-gray-300 text-sm font-mono bg-gray-900/50 p-3 rounded border border-gray-700/50 backdrop-blur-sm"
      }, prompt.content))), /*#__PURE__*/React.createElement("div", {
        className: "flex flex-col justify-center items-center p-2 border-l border-gray-700/50 bg-gray-900/50"
      }, /*#__PURE__*/React.createElement("button", {
        onClick: function onClick() {
          return handleCopyPrompt(prompt.content);
        },
        className: "p-2 text-gray-400 hover:text-white hover:bg-gray-700 rounded-full transition-colors mb-2 hover:scale-110 transform duration-200",
        title: "Copy to clipboard"
      }, /*#__PURE__*/React.createElement(AwesomeIcon, {
        name: faCopy
      })), /*#__PURE__*/React.createElement("button", {
        onClick: function onClick() {
          return handleUsePrompt(prompt.content);
        },
        className: "p-2 text-teal-400 hover:text-teal-300 hover:bg-teal-900/50 rounded-full transition-colors hover:scale-110 transform duration-200",
        title: "Use in chat"
      }, /*#__PURE__*/React.createElement(AwesomeIcon, {
        name: faPaperPlane
      })))));
    })));
  })))))));
};
export default PromptsModal;